var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      height: 700,
      width: "700",
      "max-width": "700",
      scrollable: "",
      title: _vm.$t("label_essweb_approvalTemplate_form_dialog_newNodeTitle"),
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: {
                curStep: _vm.curStep,
                items: _vm.stepper,
                backgroundColor: "white",
                contentClass: "white pa-3 ",
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    dense: "",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.approvalNodeData
                                          .flow_template_node_name,
                                      maxlength: "100",
                                      TrigerInit: _vm.show,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_dialog_nodeNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.approvalNodeData.flow_template_node_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    dense: "",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "500",
                                      TrigerInit: _vm.show,
                                      bindData:
                                        _vm.approvalNodeData
                                          .flow_template_node_description,
                                      label: _vm.$t(
                                        "label_essweb_approvalTemplate_form_dialog_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.approvalNodeData.flow_template_node_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    dense: "",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      "single-line": "",
                                      dense: "",
                                      filled: "",
                                      counter: "500",
                                    },
                                    model: {
                                      value: _vm.approvalNodeData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalNodeData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "approvalNodeData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        { staticClass: "pa-3", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text-subtitle-2" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_approvalTemplate_form_dialog_actionLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-container",
                                {
                                  staticClass: "pa-0 ma-0",
                                  attrs: { fluid: "" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_canRedirectionItemLabel"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .is_allow_forward,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "is_allow_forward",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.is_allow_forward",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_canCancelLabel"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .is_allow_revoke,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "is_allow_revoke",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.is_allow_revoke",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_canRefusalLabel"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .is_allow_rollback,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "is_allow_rollback",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.is_allow_rollback",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_canSkipLabel"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .is_allow_skip,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "is_allow_skip",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.is_allow_skip",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_canViewAttachmentsLabel"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .is_allow_view_attachments,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "is_allow_view_attachments",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.is_allow_view_attachments",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 pt-3",
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text-subtitle-2" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_approvalTemplate_form_dialog_approverLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-container",
                                {
                                  staticClass: "pa-0 ma-0",
                                  attrs: { fluid: "" },
                                },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticClass: "mt-1",
                                      attrs: { "hide-details": "" },
                                      model: {
                                        value: _vm.approvers,
                                        callback: function ($$v) {
                                          _vm.approvers = $$v
                                        },
                                        expression: "approvers",
                                      },
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel"
                                          ),
                                          value: 0,
                                        },
                                      }),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_approverJobLabel"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                      _vm.approvers == 2
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allJob,
                                              filled: "",
                                              chips: "",
                                              dense: "",
                                              multiple: "",
                                              "hide-details": "",
                                              filter: _vm.jobFliter,
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text": "view_fields",
                                              "item-value": "value_field",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                _vm.allJob.length > 0
                                                  ? {
                                                      key: "prepend-item",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "px-4",
                                                              attrs: {
                                                                dense: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.$nextTick(
                                                                      function () {
                                                                        if (
                                                                          _vm
                                                                            .approvalNodeData
                                                                            .forJob
                                                                            .length ===
                                                                          _vm
                                                                            .allJob
                                                                            .length
                                                                        ) {
                                                                          _vm.approvalNodeData.forJob =
                                                                            []
                                                                        } else {
                                                                          _vm.approvalNodeData.forJob =
                                                                            []
                                                                          _vm.allJob.map(
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              _vm.approvalNodeData.forJob.push(
                                                                                item.value_field
                                                                              )
                                                                            }
                                                                          )
                                                                        }
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                {
                                                                  staticClass:
                                                                    "mx-0 my-0 mr-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "material-icons-round",
                                                                      class:
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .forJob
                                                                          .length !==
                                                                          0 &&
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .forJob
                                                                          .length ===
                                                                          _vm
                                                                            .allJob
                                                                            .length
                                                                          ? "primary--text"
                                                                          : _vm
                                                                              .approvalNodeData
                                                                              .forJob
                                                                              .length >
                                                                              0 &&
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .forJob
                                                                              .length !==
                                                                              _vm
                                                                                .allJob
                                                                                .length
                                                                          ? "primary--text"
                                                                          : "text--secondary",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .forJob
                                                                              .length !==
                                                                              0 &&
                                                                              _vm
                                                                                .approvalNodeData
                                                                                .forJob
                                                                                .length ===
                                                                                _vm
                                                                                  .allJob
                                                                                  .length
                                                                              ? "check_box"
                                                                              : _vm
                                                                                  .approvalNodeData
                                                                                  .forJob
                                                                                  .length >
                                                                                  0 &&
                                                                                _vm
                                                                                  .approvalNodeData
                                                                                  .forJob
                                                                                  .length !==
                                                                                  _vm
                                                                                    .allJob
                                                                                    .length
                                                                              ? "indeterminate_check_box"
                                                                              : "check_box_outline_blank"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "label_essweb_system_select_selectAllLabel"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("v-divider"),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    }
                                                  : null,
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      data.index <
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  close: "",
                                                                  "input-value":
                                                                    data.selected,
                                                                },
                                                                on: {
                                                                  click:
                                                                    data.select,
                                                                  "click:close":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeJob(
                                                                        data.item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-chip",
                                                              data.attrs,
                                                              false
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$getCommonLangValue(
                                                                      data.item
                                                                        .view_fields
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      data.index ===
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text--primary py-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " ..." +
                                                                  _vm._s(
                                                                    _vm
                                                                      .approvalNodeData
                                                                      .forJob
                                                                      .length -
                                                                      _vm
                                                                        .$selectSetting
                                                                        .maxChips
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "label_essweb_selection_moreItemLabel"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          staticClass: "pa-0",
                                                          attrs: {
                                                            width: "100%",
                                                            nav: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                                nav: "",
                                                                "two-line": "",
                                                                dense: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .view_fields
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .f1
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData.forJob,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "forJob",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.forJob",
                                            },
                                          })
                                        : _vm._e(),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_staffLabel"
                                          ),
                                          value: 3,
                                        },
                                      }),
                                      _vm.approvers == 3
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allStaff,
                                              filled: "",
                                              chips: "",
                                              filter: _vm.$staffFilter,
                                              dense: "",
                                              multiple: "",
                                              "hide-details": "",
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text": "staff_code",
                                              "item-value": "staff_id",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                _vm.allStaff.length > 0
                                                  ? {
                                                      key: "prepend-item",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "px-4",
                                                              attrs: {
                                                                dense: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.$nextTick(
                                                                      function () {
                                                                        if (
                                                                          _vm
                                                                            .approvalNodeData
                                                                            .Staffs
                                                                            .length ===
                                                                          _vm
                                                                            .allStaff
                                                                            .length
                                                                        ) {
                                                                          _vm.approvalNodeData.Staffs =
                                                                            []
                                                                        } else {
                                                                          _vm.approvalNodeData.Staffs =
                                                                            []
                                                                          _vm.allStaff.map(
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              _vm.approvalNodeData.Staffs.push(
                                                                                item.staff_id
                                                                              )
                                                                            }
                                                                          )
                                                                        }
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                {
                                                                  staticClass:
                                                                    "mx-0 my-0 mr-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "material-icons-round",
                                                                      class:
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .Staffs
                                                                          .length !==
                                                                          0 &&
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .Staffs
                                                                          .length ===
                                                                          _vm
                                                                            .allStaff
                                                                            .length
                                                                          ? "primary--text"
                                                                          : _vm
                                                                              .approvalNodeData
                                                                              .Staffs
                                                                              .length >
                                                                              0 &&
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .Staffs
                                                                              .length !==
                                                                              _vm
                                                                                .allStaff
                                                                                .length
                                                                          ? "primary--text"
                                                                          : "text--secondary",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .Staffs
                                                                              .length !==
                                                                              0 &&
                                                                              _vm
                                                                                .approvalNodeData
                                                                                .Staffs
                                                                                .length ===
                                                                                _vm
                                                                                  .allStaff
                                                                                  .length
                                                                              ? "check_box"
                                                                              : _vm
                                                                                  .approvalNodeData
                                                                                  .Staffs
                                                                                  .length >
                                                                                  0 &&
                                                                                _vm
                                                                                  .approvalNodeData
                                                                                  .Staffs
                                                                                  .length !==
                                                                                  _vm
                                                                                    .allStaff
                                                                                    .length
                                                                              ? "indeterminate_check_box"
                                                                              : "check_box_outline_blank"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "label_essweb_system_select_selectAllLabel"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("v-divider"),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    }
                                                  : null,
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      data.index <
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  close: "",
                                                                  "input-value":
                                                                    data.selected,
                                                                },
                                                                on: {
                                                                  click:
                                                                    data.select,
                                                                  "click:close":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeStaff(
                                                                        data.item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-chip",
                                                              data.attrs,
                                                              false
                                                            ),
                                                            [
                                                              _c(
                                                                "StaffAvatar",
                                                                {
                                                                  attrs: {
                                                                    left: "",
                                                                    src: data
                                                                      .item
                                                                      .staff_avatar,
                                                                    staff_name:
                                                                      data.item
                                                                        .preferred_name,
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$getCommonLangValue(
                                                                      data.item
                                                                        .preferred_name
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      data.index ===
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text--primary py-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " ..." +
                                                                  _vm._s(
                                                                    _vm
                                                                      .approvalNodeData
                                                                      .Staffs
                                                                      .length -
                                                                      _vm
                                                                        .$selectSetting
                                                                        .maxChips
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "label_essweb_selection_moreItemLabel"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            rounded: "",
                                                            width: "100%",
                                                            nav: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                                nav: "",
                                                                "two-line": "",
                                                                dense: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-avatar",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 mr-1 white--text",
                                                                  attrs: {
                                                                    size: "36",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "StaffAvatar",
                                                                    {
                                                                      attrs: {
                                                                        size: "36",
                                                                        src: data
                                                                          .item
                                                                          .staff_avatar,
                                                                        staff_name:
                                                                          data
                                                                            .item
                                                                            .preferred_name,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      staticClass:
                                                                        "text-body-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .preferred_name
                                                                          )
                                                                        ) + " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text--secondary text-caption-xs",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              data
                                                                                .item
                                                                                .staff_code
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .job_post_name
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData.Staffs,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "Staffs",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.Staffs",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.allNode.length > 0
                                        ? _c("v-radio", {
                                            attrs: {
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_nodalApproverLabel"
                                              ),
                                              disabled: _vm.allNode.length == 0,
                                              value: 4,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.approvers == 4
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allNode,
                                              filled: "",
                                              chips: "",
                                              dense: "",
                                              "hide-details": "",
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text":
                                                "flow_template_node_name",
                                              "item-value": "number",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              close: "",
                                                              "input-value":
                                                                data.selected,
                                                            },
                                                            on: {
                                                              click:
                                                                data.select,
                                                              "click:close":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  _vm.approvalNodeData.applicantMan =
                                                                    ""
                                                                },
                                                            },
                                                          },
                                                          "v-chip",
                                                          data.attrs,
                                                          false
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getCommonLangValue(
                                                                  data.item
                                                                    .flow_template_node_name
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            rounded: "",
                                                            width: "100%",
                                                            nav: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                data
                                                                                  .item
                                                                                  .flow_template_node_name
                                                                              )
                                                                            ),
                                                                        },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                data
                                                                                  .item
                                                                                  .flow_template_node_description
                                                                              )
                                                                            ),
                                                                        },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3404279272
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .applicantMan,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "applicantMan",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.applicantMan",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.allNode.length > 0
                                        ? _c("v-radio", {
                                            attrs: {
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel"
                                              ),
                                              disabled: _vm.allNode.length == 0,
                                              value: 5,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.approvers == 5
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allNode,
                                              filled: "",
                                              chips: "",
                                              dense: "",
                                              "hide-details": "",
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text":
                                                "flow_template_node_name",
                                              "item-value": "number",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              close: "",
                                                              "input-value":
                                                                data.selected,
                                                            },
                                                            on: {
                                                              click:
                                                                data.select,
                                                              "click:close":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  _vm.approvalNodeData.applicantHeader =
                                                                    ""
                                                                },
                                                            },
                                                          },
                                                          "v-chip",
                                                          data.attrs,
                                                          false
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getCommonLangValue(
                                                                  data.item
                                                                    .flow_template_node_name
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            rounded: "",
                                                            width: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                data
                                                                                  .item
                                                                                  .flow_template_node_name
                                                                              )
                                                                            ),
                                                                        },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                data
                                                                                  .item
                                                                                  .flow_template_node_description
                                                                              )
                                                                            ),
                                                                        },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3984714234
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .applicantHeader,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "applicantHeader",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.applicantHeader",
                                            },
                                          })
                                        : _vm._e(),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel"
                                          ),
                                          value: 6,
                                        },
                                      }),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_senderStaffShipLabel"
                                          ),
                                          value: 7,
                                        },
                                      }),
                                      _vm.approvers == 7
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allShip,
                                              filled: "",
                                              chips: "",
                                              dense: "",
                                              multiple: "",
                                              "hide-details": "",
                                              filter: _vm.shipFliter,
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text": "view_fields",
                                              "item-value": "value_field",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                _vm.allShip.length > 0
                                                  ? {
                                                      key: "prepend-item",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "px-4",
                                                              attrs: {
                                                                dense: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.$nextTick(
                                                                      function () {
                                                                        if (
                                                                          _vm
                                                                            .approvalNodeData
                                                                            .correlation
                                                                            .length ===
                                                                          _vm
                                                                            .allShip
                                                                            .length
                                                                        ) {
                                                                          _vm.approvalNodeData.correlation =
                                                                            []
                                                                        } else {
                                                                          _vm.approvalNodeData.correlation =
                                                                            []
                                                                          _vm.allShip.map(
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              _vm.approvalNodeData.correlation.push(
                                                                                item.value_field
                                                                              )
                                                                            }
                                                                          )
                                                                        }
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                {
                                                                  staticClass:
                                                                    "mx-0 my-0 mr-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "material-icons-round",
                                                                      class:
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .correlation
                                                                          .length !==
                                                                          0 &&
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .correlation
                                                                          .length ===
                                                                          _vm
                                                                            .allShip
                                                                            .length
                                                                          ? "primary--text"
                                                                          : _vm
                                                                              .approvalNodeData
                                                                              .correlation
                                                                              .length >
                                                                              0 &&
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .correlation
                                                                              .length !==
                                                                              _vm
                                                                                .allShip
                                                                                .length
                                                                          ? "primary--text"
                                                                          : "text--secondary",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .correlation
                                                                              .length !==
                                                                              0 &&
                                                                              _vm
                                                                                .approvalNodeData
                                                                                .correlation
                                                                                .length ===
                                                                                _vm
                                                                                  .allShip
                                                                                  .length
                                                                              ? "check_box"
                                                                              : _vm
                                                                                  .approvalNodeData
                                                                                  .correlation
                                                                                  .length >
                                                                                  0 &&
                                                                                _vm
                                                                                  .approvalNodeData
                                                                                  .correlation
                                                                                  .length !==
                                                                                  _vm
                                                                                    .allShip
                                                                                    .length
                                                                              ? "indeterminate_check_box"
                                                                              : "check_box_outline_blank"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "label_essweb_system_select_selectAllLabel"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("v-divider"),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    }
                                                  : null,
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      data.index <
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  close: "",
                                                                  "input-value":
                                                                    data.selected,
                                                                },
                                                                on: {
                                                                  click:
                                                                    data.select,
                                                                  "click:close":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeShip(
                                                                        data.item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-chip",
                                                              data.attrs,
                                                              false
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$getCommonLangValue(
                                                                      data.item
                                                                        .view_fields
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      data.index ===
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text--primary py-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " ..." +
                                                                  _vm._s(
                                                                    _vm
                                                                      .approvalNodeData
                                                                      .correlation
                                                                      .length -
                                                                      _vm
                                                                        .$selectSetting
                                                                        .maxChips
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "label_essweb_selection_moreItemLabel"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            rounded: "",
                                                            width: "100%",
                                                            nav: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                                nav: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .view_fields
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .correlation,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "correlation",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.correlation",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 pt-3",
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text-subtitle-2" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_approvalTemplate_form_dialog_emailCCLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-container",
                                {
                                  staticClass: "pa-0 ma-0",
                                  attrs: { fluid: "" },
                                },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticClass: "mt-1",
                                      attrs: { "hide-details": "" },
                                      model: {
                                        value: _vm.copySender,
                                        callback: function ($$v) {
                                          _vm.copySender = $$v
                                        },
                                        expression: "copySender",
                                      },
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_notCCLabel"
                                          ),
                                          value: -1,
                                        },
                                      }),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_senderSupervisorLabel"
                                          ),
                                          value: 0,
                                        },
                                      }),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_approverSupervisorLabel"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_approverJobLabel"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                      _vm.copySender == 2
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allJob,
                                              filled: "",
                                              chips: "",
                                              dense: "",
                                              multiple: "",
                                              "hide-details": "",
                                              filter: _vm.jobFliter,
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text": "view_fields",
                                              "item-value": "value_field",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                _vm.allJob.length > 0
                                                  ? {
                                                      key: "prepend-item",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "px-4",
                                                              attrs: {
                                                                dense: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.$nextTick(
                                                                      function () {
                                                                        if (
                                                                          _vm
                                                                            .approvalNodeData
                                                                            .forJob_cc
                                                                            .length ===
                                                                          _vm
                                                                            .allJob
                                                                            .length
                                                                        ) {
                                                                          _vm.approvalNodeData.forJob_cc =
                                                                            []
                                                                        } else {
                                                                          _vm.approvalNodeData.forJob_cc =
                                                                            []
                                                                          _vm.allJob.map(
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              _vm.approvalNodeData.forJob_cc.push(
                                                                                item.value_field
                                                                              )
                                                                            }
                                                                          )
                                                                        }
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                {
                                                                  staticClass:
                                                                    "mx-0 my-0 mr-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "material-icons-round",
                                                                      class:
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .forJob_cc
                                                                          .length !==
                                                                          0 &&
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .forJob_cc
                                                                          .length ===
                                                                          _vm
                                                                            .allJob
                                                                            .length
                                                                          ? "primary--text"
                                                                          : _vm
                                                                              .approvalNodeData
                                                                              .forJob_cc
                                                                              .length >
                                                                              0 &&
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .forJob_cc
                                                                              .length !==
                                                                              _vm
                                                                                .allJob
                                                                                .length
                                                                          ? "primary--text"
                                                                          : "text--secondary",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .forJob_cc
                                                                              .length !==
                                                                              0 &&
                                                                              _vm
                                                                                .approvalNodeData
                                                                                .forJob_cc
                                                                                .length ===
                                                                                _vm
                                                                                  .allJob
                                                                                  .length
                                                                              ? "check_box"
                                                                              : _vm
                                                                                  .approvalNodeData
                                                                                  .forJob_cc
                                                                                  .length >
                                                                                  0 &&
                                                                                _vm
                                                                                  .approvalNodeData
                                                                                  .forJob_cc
                                                                                  .length !==
                                                                                  _vm
                                                                                    .allJob
                                                                                    .length
                                                                              ? "indeterminate_check_box"
                                                                              : "check_box_outline_blank"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "label_essweb_system_select_selectAllLabel"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("v-divider"),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    }
                                                  : null,
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      data.index <
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  close: "",
                                                                  "input-value":
                                                                    data.selected,
                                                                },
                                                                on: {
                                                                  click:
                                                                    data.select,
                                                                  "click:close":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeJob(
                                                                        data.item,
                                                                        true
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-chip",
                                                              data.attrs,
                                                              false
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$getCommonLangValue(
                                                                      data.item
                                                                        .view_fields
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      data.index ===
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text--primary py-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " ..." +
                                                                  _vm._s(
                                                                    _vm
                                                                      .approvalNodeData
                                                                      .forJob_cc
                                                                      .length -
                                                                      _vm
                                                                        .$selectSetting
                                                                        .maxChips
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "label_essweb_selection_moreItemLabel"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          staticClass: "pa-0",
                                                          attrs: {
                                                            width: "100%",
                                                            nav: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                                nav: "",
                                                                "two-line": "",
                                                                dense: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .view_fields
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .f1
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData.forJob_cc,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "forJob_cc",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.forJob_cc",
                                            },
                                          })
                                        : _vm._e(),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_staffLabel"
                                          ),
                                          value: 3,
                                        },
                                      }),
                                      _vm.copySender == 3
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allStaff,
                                              filled: "",
                                              chips: "",
                                              filter: _vm.$staffFilter,
                                              dense: "",
                                              multiple: "",
                                              "hide-details": "",
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text": "staff_code",
                                              "item-value": "staff_id",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                _vm.allStaff.length > 0
                                                  ? {
                                                      key: "prepend-item",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "px-4",
                                                              attrs: {
                                                                dense: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.$nextTick(
                                                                      function () {
                                                                        if (
                                                                          _vm
                                                                            .approvalNodeData
                                                                            .Staffs_cc
                                                                            .length ===
                                                                          _vm
                                                                            .allStaff
                                                                            .length
                                                                        ) {
                                                                          _vm.approvalNodeData.Staffs_cc =
                                                                            []
                                                                        } else {
                                                                          _vm.approvalNodeData.Staffs_cc =
                                                                            []
                                                                          _vm.allStaff.map(
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              _vm.approvalNodeData.Staffs_cc.push(
                                                                                item.staff_id
                                                                              )
                                                                            }
                                                                          )
                                                                        }
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                {
                                                                  staticClass:
                                                                    "mx-0 my-0 mr-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "material-icons-round",
                                                                      class:
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .Staffs_cc
                                                                          .length !==
                                                                          0 &&
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .Staffs_cc
                                                                          .length ===
                                                                          _vm
                                                                            .allStaff
                                                                            .length
                                                                          ? "primary--text"
                                                                          : _vm
                                                                              .approvalNodeData
                                                                              .Staffs_cc
                                                                              .length >
                                                                              0 &&
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .Staffs_cc
                                                                              .length !==
                                                                              _vm
                                                                                .allStaff
                                                                                .length
                                                                          ? "primary--text"
                                                                          : "text--secondary",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .Staffs_cc
                                                                              .length !==
                                                                              0 &&
                                                                              _vm
                                                                                .approvalNodeData
                                                                                .Staffs_cc
                                                                                .length ===
                                                                                _vm
                                                                                  .allStaff
                                                                                  .length
                                                                              ? "check_box"
                                                                              : _vm
                                                                                  .approvalNodeData
                                                                                  .Staffs_cc
                                                                                  .length >
                                                                                  0 &&
                                                                                _vm
                                                                                  .approvalNodeData
                                                                                  .Staffs_cc
                                                                                  .length !==
                                                                                  _vm
                                                                                    .allStaff
                                                                                    .length
                                                                              ? "indeterminate_check_box"
                                                                              : "check_box_outline_blank"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "label_essweb_system_select_selectAllLabel"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("v-divider"),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    }
                                                  : null,
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      data.index <
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  close: "",
                                                                  "input-value":
                                                                    data.selected,
                                                                },
                                                                on: {
                                                                  click:
                                                                    data.select,
                                                                  "click:close":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeStaff(
                                                                        data.item,
                                                                        true
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-chip",
                                                              data.attrs,
                                                              false
                                                            ),
                                                            [
                                                              _c(
                                                                "StaffAvatar",
                                                                {
                                                                  attrs: {
                                                                    left: "",
                                                                    src: data
                                                                      .item
                                                                      .staff_avatar,
                                                                    staff_name:
                                                                      data.item
                                                                        .preferred_name,
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$getCommonLangValue(
                                                                      data.item
                                                                        .preferred_name
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      data.index ===
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text--primary py-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " ..." +
                                                                  _vm._s(
                                                                    _vm
                                                                      .approvalNodeData
                                                                      .Staffs_cc
                                                                      .length -
                                                                      _vm
                                                                        .$selectSetting
                                                                        .maxChips
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "label_essweb_selection_moreItemLabel"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            rounded: "",
                                                            width: "100%",
                                                            nav: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                                nav: "",
                                                                "two-line": "",
                                                                dense: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-avatar",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 mr-1 white--text",
                                                                  attrs: {
                                                                    size: "36",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "StaffAvatar",
                                                                    {
                                                                      attrs: {
                                                                        size: "36",
                                                                        src: data
                                                                          .item
                                                                          .staff_avatar,
                                                                        staff_name:
                                                                          data
                                                                            .item
                                                                            .preferred_name,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      staticClass:
                                                                        "text-body-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .preferred_name
                                                                          )
                                                                        ) + " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text--secondary text-caption-xs",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              data
                                                                                .item
                                                                                .staff_code
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .job_post_name
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData.Staffs_cc,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "Staffs_cc",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.Staffs_cc",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.allNode.length > 0
                                        ? _c("v-radio", {
                                            attrs: {
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_nodalApproverLabel"
                                              ),
                                              disabled: _vm.allNode.length == 0,
                                              value: 4,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.copySender == 4
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allNode,
                                              filled: "",
                                              chips: "",
                                              dense: "",
                                              "hide-details": "",
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text":
                                                "flow_template_node_name",
                                              "item-value": "number",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              close: "",
                                                              "input-value":
                                                                data.selected,
                                                            },
                                                            on: {
                                                              click:
                                                                data.select,
                                                              "click:close":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  _vm.approvalNodeData.applicantMan_cc =
                                                                    ""
                                                                },
                                                            },
                                                          },
                                                          "v-chip",
                                                          data.attrs,
                                                          false
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getCommonLangValue(
                                                                  data.item
                                                                    .flow_template_node_name
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            rounded: "",
                                                            width: "100%",
                                                            nav: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                data
                                                                                  .item
                                                                                  .flow_template_node_name
                                                                              )
                                                                            ),
                                                                        },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                data
                                                                                  .item
                                                                                  .flow_template_node_description
                                                                              )
                                                                            ),
                                                                        },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              402269015
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .applicantMan_cc,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "applicantMan_cc",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.applicantMan_cc",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.allNode.length > 0
                                        ? _c("v-radio", {
                                            attrs: {
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_nodalApproverSupervisorLabel"
                                              ),
                                              disabled: _vm.allNode.length == 0,
                                              value: 5,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.copySender == 5
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allNode,
                                              filled: "",
                                              chips: "",
                                              dense: "",
                                              "hide-details": "",
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text":
                                                "flow_template_node_name",
                                              "item-value": "number",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-chip",
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              close: "",
                                                              "input-value":
                                                                data.selected,
                                                            },
                                                            on: {
                                                              click:
                                                                data.select,
                                                              "click:close":
                                                                function (
                                                                  $event
                                                                ) {
                                                                  _vm.approvalNodeData.applicantHeader_cc =
                                                                    ""
                                                                },
                                                            },
                                                          },
                                                          "v-chip",
                                                          data.attrs,
                                                          false
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getCommonLangValue(
                                                                  data.item
                                                                    .flow_template_node_name
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            rounded: "",
                                                            width: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                data
                                                                                  .item
                                                                                  .flow_template_node_name
                                                                              )
                                                                            ),
                                                                        },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "v-list-item-subtitle",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm.$getCommonLangValue(
                                                                                data
                                                                                  .item
                                                                                  .flow_template_node_description
                                                                              )
                                                                            ),
                                                                        },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              4205061957
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .applicantHeader_cc,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "applicantHeader_cc",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.applicantHeader_cc",
                                            },
                                          })
                                        : _vm._e(),
                                      0
                                        ? _c("v-radio", {
                                            attrs: {
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_senderAllSupervisorLabel"
                                              ),
                                              value: 6,
                                            },
                                          })
                                        : _vm._e(),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_senderStaffShipLabel"
                                          ),
                                          value: 7,
                                        },
                                      }),
                                      _vm.copySender == 7
                                        ? _c("v-autocomplete", {
                                            staticClass: "py-2",
                                            attrs: {
                                              items: _vm.allShip,
                                              filled: "",
                                              chips: "",
                                              dense: "",
                                              multiple: "",
                                              "hide-details": "",
                                              filter: _vm.shipFliter,
                                              "single-line": "",
                                              color: "primary lighten-2",
                                              "item-text": "view_fields",
                                              "item-value": "value_field",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-data",
                                                  fn: function () {
                                                    return [_c("noContent")]
                                                  },
                                                  proxy: true,
                                                },
                                                _vm.allShip.length > 0
                                                  ? {
                                                      key: "prepend-item",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "px-4",
                                                              attrs: {
                                                                dense: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.$nextTick(
                                                                      function () {
                                                                        if (
                                                                          _vm
                                                                            .approvalNodeData
                                                                            .correlation_cc
                                                                            .length ===
                                                                          _vm
                                                                            .allShip
                                                                            .length
                                                                        ) {
                                                                          _vm.approvalNodeData.correlation_cc =
                                                                            []
                                                                        } else {
                                                                          _vm.approvalNodeData.correlation_cc =
                                                                            []
                                                                          _vm.allShip.map(
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              _vm.approvalNodeData.correlation_cc.push(
                                                                                item.value_field
                                                                              )
                                                                            }
                                                                          )
                                                                        }
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                {
                                                                  staticClass:
                                                                    "mx-0 my-0 mr-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "material-icons-round",
                                                                      class:
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .correlation_cc
                                                                          .length !==
                                                                          0 &&
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .correlation_cc
                                                                          .length ===
                                                                          _vm
                                                                            .allShip
                                                                            .length
                                                                          ? "primary--text"
                                                                          : _vm
                                                                              .approvalNodeData
                                                                              .correlation_cc
                                                                              .length >
                                                                              0 &&
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .correlation_cc
                                                                              .length !==
                                                                              _vm
                                                                                .allShip
                                                                                .length
                                                                          ? "primary--text"
                                                                          : "text--secondary",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .approvalNodeData
                                                                              .correlation_cc
                                                                              .length !==
                                                                              0 &&
                                                                              _vm
                                                                                .approvalNodeData
                                                                                .correlation_cc
                                                                                .length ===
                                                                                _vm
                                                                                  .allShip
                                                                                  .length
                                                                              ? "check_box"
                                                                              : _vm
                                                                                  .approvalNodeData
                                                                                  .correlation_cc
                                                                                  .length >
                                                                                  0 &&
                                                                                _vm
                                                                                  .approvalNodeData
                                                                                  .correlation_cc
                                                                                  .length !==
                                                                                  _vm
                                                                                    .allShip
                                                                                    .length
                                                                              ? "indeterminate_check_box"
                                                                              : "check_box_outline_blank"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "label_essweb_system_select_selectAllLabel"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("v-divider"),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    }
                                                  : null,
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      data.index <
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "v-chip",
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  close: "",
                                                                  "input-value":
                                                                    data.selected,
                                                                },
                                                                on: {
                                                                  click:
                                                                    data.select,
                                                                  "click:close":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeShip(
                                                                        data.item,
                                                                        true
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "v-chip",
                                                              data.attrs,
                                                              false
                                                            ),
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$getCommonLangValue(
                                                                      data.item
                                                                        .view_fields
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      data.index ===
                                                      _vm.$selectSetting
                                                        .maxChips
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text--primary py-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " ..." +
                                                                  _vm._s(
                                                                    _vm
                                                                      .approvalNodeData
                                                                      .correlation_cc
                                                                      .length -
                                                                      _vm
                                                                        .$selectSetting
                                                                        .maxChips
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "label_essweb_selection_moreItemLabel"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          attrs: {
                                                            rounded: "",
                                                            width: "100%",
                                                            nav: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              attrs: {
                                                                rouned: "",
                                                                width: "100%",
                                                                nav: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-content",
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$getCommonLangValue(
                                                                            data
                                                                              .item
                                                                              .view_fields
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .correlation_cc,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "correlation_cc",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.correlation_cc",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 pt-3",
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text-subtitle-2" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_approvalTemplate_form_dialog_IsNotificationLabel"
                                        )
                                      ) +
                                      "? "
                                  ),
                                ]
                              ),
                              _c(
                                "v-container",
                                {
                                  staticClass: "pa-0 ma-0",
                                  attrs: { fluid: "" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            xs: "12",
                                            sm: "12",
                                            md: "12",
                                            lg: "12",
                                            cols: "auto",
                                          },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              label: _vm.$t(
                                                "label_essweb_approvalTemplate_form_dialog_notificationLabel"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.approvalNodeData
                                                  .is_alert_notification,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.approvalNodeData,
                                                  "is_alert_notification",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "approvalNodeData.is_alert_notification",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm.approvalNodeData.is_alert_notification
                                        ? _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                xs: "12",
                                                sm: "12",
                                                md: "6",
                                                lg: "6",
                                                cols: "12",
                                              },
                                            },
                                            [
                                              _c("numberInputTextFiled", {
                                                attrs: {
                                                  rules: _vm.$GetRules(
                                                    [
                                                      "_Number_negative",
                                                      "_Length_Rules",
                                                    ],
                                                    [null, 11]
                                                  ),
                                                  label: _vm.$t(
                                                    "label_essweb_approvalTemplate_form_dialog_approvalNotiOverDateLabel"
                                                  ),
                                                  isNotRequire: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.approvalNodeData
                                                      .approver_notify_threshold,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.approvalNodeData,
                                                      "approver_notify_threshold",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "approvalNodeData.approver_notify_threshold",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form2", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    dense: "",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_approvalTemplate_form_dialog_filedLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.allField,
                                      "item-text": "view_fields",
                                      "item-value": "value_field",
                                      "small-chips": "",
                                      dense: "",
                                      "single-line": "",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      "deletable-chips": "",
                                      multiple: "",
                                      filled: "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "no-data",
                                          fn: function () {
                                            return [_c("noContent")]
                                          },
                                          proxy: true,
                                        },
                                        _vm.allField.length > 0
                                          ? {
                                              key: "prepend-item",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass: "px-4",
                                                      attrs: { dense: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.$nextTick(
                                                            function () {
                                                              if (
                                                                _vm
                                                                  .approvalNodeData
                                                                  .field_uuid
                                                                  .length ===
                                                                _vm.allField
                                                                  .length
                                                              ) {
                                                                _vm.approvalNodeData.field_uuid =
                                                                  []
                                                              } else {
                                                                _vm.approvalNodeData.field_uuid =
                                                                  []
                                                                _vm.allField.map(
                                                                  function (
                                                                    item
                                                                  ) {
                                                                    _vm.approvalNodeData.field_uuid.push(
                                                                      item.value_field
                                                                    )
                                                                  }
                                                                )
                                                              }
                                                            }
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-action",
                                                        {
                                                          staticClass:
                                                            "mx-0 my-0 mr-1",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                              class:
                                                                _vm
                                                                  .approvalNodeData
                                                                  .field_uuid
                                                                  .length !==
                                                                  0 &&
                                                                _vm
                                                                  .approvalNodeData
                                                                  .field_uuid
                                                                  .length ===
                                                                  _vm.allField
                                                                    .length
                                                                  ? "primary--text"
                                                                  : _vm
                                                                      .approvalNodeData
                                                                      .field_uuid
                                                                      .length >
                                                                      0 &&
                                                                    _vm
                                                                      .approvalNodeData
                                                                      .field_uuid
                                                                      .length !==
                                                                      _vm
                                                                        .allField
                                                                        .length
                                                                  ? "primary--text"
                                                                  : "text--secondary",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .approvalNodeData
                                                                      .field_uuid
                                                                      .length !==
                                                                      0 &&
                                                                      _vm
                                                                        .approvalNodeData
                                                                        .field_uuid
                                                                        .length ===
                                                                        _vm
                                                                          .allField
                                                                          .length
                                                                      ? "check_box"
                                                                      : _vm
                                                                          .approvalNodeData
                                                                          .field_uuid
                                                                          .length >
                                                                          0 &&
                                                                        _vm
                                                                          .approvalNodeData
                                                                          .field_uuid
                                                                          .length !==
                                                                          _vm
                                                                            .allField
                                                                            .length
                                                                      ? "indeterminate_check_box"
                                                                      : "check_box_outline_blank"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "label_essweb_system_select_selectAllLabel"
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-divider"),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                        {
                                          key: "selection",
                                          fn: function (data) {
                                            return [
                                              data.index <
                                              _vm.$selectSetting.maxChips
                                                ? _c(
                                                    "v-chip",
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          close: "",
                                                          "input-value":
                                                            data.selected,
                                                        },
                                                        on: {
                                                          click: data.select,
                                                          "click:close":
                                                            function ($event) {
                                                              return _vm.removeUuid(
                                                                data.item
                                                              )
                                                            },
                                                        },
                                                      },
                                                      "v-chip",
                                                      data.attrs,
                                                      false
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$getCommonLangValue(
                                                              data.item
                                                                .view_fields
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              data.index ===
                                              _vm.$selectSetting.maxChips
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text--primary py-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " ..." +
                                                          _vm._s(
                                                            _vm.approvalNodeData
                                                              .field_uuid
                                                              .length -
                                                              _vm.$selectSetting
                                                                .maxChips
                                                          ) +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_selection_moreItemLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c("v-list-item-title", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        data.item.view_fields
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.approvalNodeData.field_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.approvalNodeData,
                                          "field_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "approvalNodeData.field_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn:
                  _vm.step == _vm.curStep && _vm.curStep != 0 ? true : false,
                step: _vm.step == _vm.curStep ? false : true,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toNew,
                cancel: _vm.closeDialog,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }